import { defineComponent as _defineComponent } from 'vue'
import Modal from '../../../../components/Modal/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StorageRequestDialog',
  emits: ["cancel", "confirm"],
  setup(__props) {



return { __sfc: true,Modal }
}

})